import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SharedService } from './shared.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class LoadingService extends SharedService {
    constructor(public http: HttpClient) {
        super(http, 'loading');
    }

    setLoading = (isLoading: boolean): void => this.dispatchData({ loader: true, isLoading });
}
